/** This ensures that if the user is logged in, they also have verified their email */
export default defineNuxtRouteMiddleware(() => {
	const token = useCookie("auth0.token").value;

	if (!token) {
		return;
	}

	// This comes from our `/callback` route
	const emailVerified = useCookie<boolean | undefined>(
		"auth0.email_verified",
	).value;

	// The cookie may not be set, in that case don't limit the user. The user may tamper with the cookie if they wish to, but that's mostly an issue just for them.
	if (emailVerified === false) {
		return navigateTo("/account/verify-email");
	}
});
